import { baseApi } from "../baseApi";

export const purchaseorderApi = baseApi.injectEndpoints({
     endpoints: (builder) => ({
    getGrnDetail: builder.query({
      query: (params) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.create_stock_entry_from_grn`,
        params
      })
    }),
    getNotSaveScreen: builder.mutation({
      query: (data) => ({
        url: `/api/method/frappe.model.mapper.make_mapped_doc`,
        method: 'post',
        body: data
      })
    }),
    postCreatePurchaseOrder: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.create_purchase_order`,
        method: 'post',
        body: data
      })
    }),
    postSubmitPurchaseOrder: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.submit_purchase_order`,
        method: 'post',
        body: data
      })
    }),
    postPurchaseOrderID: builder.mutation({
      query: (data) => ({
        url: `/api/method/frappe.desk.reportview.get`,
        method: 'post',
        body: data
      })
    }),
    postPurchaseOrder: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_purchase_order_list`,
        method: 'post',
        body: data
      })
    }),
    postItemList: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_item_list`,
        method: 'post',
        body: data
      })
    }),
    postItemBulk: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.parse_po_items_from_csv`,
        method: 'post',
        body: data
      })
    }),
    getWarehouseList: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_warehouse_list`,
        method: 'post',
        body: data
      })
    }),
    getVendorAddressList: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_vendor_addresses`,
        method: 'post',
        body: data
      })
    }),
    getVendorList: builder.mutation({
      query: () => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_vendor_list`,
        method: "PUT",
      }),
    }),
    getPurchaseOrderByName: builder.mutation({
      query: ({ doctype, name }) => ({
        url: `/api/method/frappe.client.get`,
        method: 'POST',
        body: new URLSearchParams({
          doctype,
          name,
        }).toString(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }),
    }),
    getAllShippingAddresses: builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_all_shipping_addresses`,
        method: 'post',
        body: data
      })
    }),
    updatePurchaseOrder: builder.mutation({
      query: (payload) => ({
        url: '/api/method/stackerbee_mobile_wms.wms.react_api.update_purchase_order',
        method: 'POST', 
        body: payload,
      }),
    }),
  }),
});

export const { useUpdatePurchaseOrderMutation ,useGetGrnDetailQuery, useGetNotSaveScreenMutation, useGetAllShippingAddressesMutation, useGetPurchaseOrderByNameMutation, usePostPurchaseOrderMutation, useGetVendorListMutation, useGetWarehouseListMutation, useGetVendorAddressListMutation, usePostItemListMutation, usePostCreatePurchaseOrderMutation, usePostSubmitPurchaseOrderMutation, usePostItemBulkMutation, usePostPurchaseOrderIDMutation } = purchaseorderApi;

